import { render, staticRenderFns } from "./PlatformsMinimizedWidget.vue?vue&type=template&id=419f7d50&scoped=true"
import script from "./PlatformsMinimizedWidget.vue?vue&type=script&lang=js"
export * from "./PlatformsMinimizedWidget.vue?vue&type=script&lang=js"
import style0 from "./PlatformsMinimizedWidget.vue?vue&type=style&index=0&id=419f7d50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419f7d50",
  null
  
)

export default component.exports